<template>
  <div>
    <vxe-toolbar
      id="toolbarId_or41"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button @click="Getdistr()">
          查询
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="500"
      :data="tableData"
    >
      <vxe-table-column>
        <vxe-table-column
          field="name"
          title="实际承运人姓名"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="listQuery.name" placeholder="请输入" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="phone"
          title="实际承运人手机号"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="listQuery.phone" placeholder="请输入" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLoadStatusName"
          title="负载状态"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.vehicleLoadStatusName"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLicenseNumber"
          title="车牌号"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.vehicleLicenseNumber"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLengthName"
          title="车长"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.vehicleLengthName"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleClassificationName"
          title="车型"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.vehicleClassificationName"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
  </div>
</template>
<script>
import { pushTarGerList } from "@/api/orderform";
export default {
  data() {
    return {
      message: "",
      loading: false,
      tableData: [],
      code: [],
      listQuery: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
        isFreeze: "0",
        authStatus: "3",
        driverType: "3",
        paiDanIsTeam: "",
        paiDanPushTarget: ""
      },
      Pagingconf: []
    };
  },
  created() {},
  methods: {
    async RefreshList() {
      this.listQuery = {
        paiDanIsTeam: this.listQuery.paiDanIsTeam,
        paiDanPushTarget: this.listQuery.paiDanPushTarget,
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      };
      await this.Getdistr();
    },
    Getdistr(row) {
      if (row) {
        this.listQuery = {
          paiDanIsTeam: row.isTeam,
          paiDanPushTarget: row.pushTarget,
          pageNum: 1,
          pageSize: 20,
          sortField: "",
          sortType: "",
          total: 0
        };
      }
      pushTarGerList(this.listQuery).then(response => {
        this.tableData = response.data.records;
        this.listQuery.total = response.data.total;
        response.data.total > 10000
          ? (this.Pagingconf = [20, 30, 50, 100, 10000])
          : (this.Pagingconf = [20, 30, 50, 100, response.data.total || 1]);
      });
    },

    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage;
      this.listQuery.pageSize = pageSize;
      this.Getdistr();
    }
  }
};
</script>

<style></style>
